// @ts-strict

import { Component, Input, OnInit } from '@angular/core';
import { flattenCategories } from '@app/core/helpers/campaign-configs-input-types';
import { ISingleCampaign, IDeviceType, SpecialCampaignData } from '@app/core/models/core-models';

@Component({
  selector: 'app-category-modal',
  templateUrl: './category-modal.component.html',
  styleUrls: ['./category-modal.component.scss']
})
export class CategoryModalComponent implements OnInit {
  @Input() currentCampaign?: ISingleCampaign | SpecialCampaignData;

  public categoriesList: IDeviceType[] = [];

  ngOnInit(): void {
    this.categoriesList = flattenCategories(this.currentCampaign?.categories || []);
  }
}
